/* Jwear AI shopping assistant chat (snippets/jw-chat.liquid). Talks only to the chat backend URL. */
(function () {
  'use strict';

  if (window.__jwChat) return;
  window.__jwChat = true;

  var root = document.querySelector('[data-jw-chat]');
  if (!root) return;

  var HISTORY_KEY = 'jw_chat_history_v1';
  var MAX_STORED = 24;
  var MAX_SENT = 12;
  var MAX_CHARS = 600;
  var MOBILE_QUERY = window.matchMedia('(max-width: 699px)');
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  var launcher = root.querySelector('[data-jw-chat-launcher]');
  var panel = root.querySelector('[data-jw-chat-panel]');
  var closeBtn = root.querySelector('[data-jw-chat-close]');
  var body = root.querySelector('[data-jw-chat-body]');
  var gate = root.querySelector('[data-jw-chat-gate]');
  var gateForm = root.querySelector('[data-jw-chat-gate-form]');
  var emailInput = root.querySelector('[data-jw-chat-email]');
  var gateStatus = root.querySelector('[data-jw-chat-gate-status]');
  var offline = root.querySelector('[data-jw-chat-offline]');
  var log = root.querySelector('[data-jw-chat-log]');
  var suggestions = root.querySelector('[data-jw-chat-suggestions]');
  var form = root.querySelector('[data-jw-chat-form]');
  var input = root.querySelector('[data-jw-chat-input]');
  var sendBtn = root.querySelector('[data-jw-chat-send]');
  var announcer = root.querySelector('[data-jw-chat-announcer]');
  var welcomeTpl = root.querySelector('[data-jw-chat-welcome]');

  var endpoint = (root.getAttribute('data-endpoint') || '').trim().replace(/\/+$/, '').replace(/\/chat$/, '');
  var siteId = (root.getAttribute('data-site-id') || '').trim();
  var listId = (root.getAttribute('data-list-id') || '').trim();
  var productHandle = (root.getAttribute('data-product-handle') || '').trim();
  var supportEmail = (root.getAttribute('data-support-email') || '').trim();
  var welcomeText = welcomeTpl ? welcomeTpl.innerHTML.replace(/&amp;/g, '&').replace(/&#39;|&apos;/g, "'").replace(/&quot;/g, '"').trim() : '';
  var storeHosts = (root.getAttribute('data-store-hosts') || '')
    .split(',')
    .map(function (h) {
      return h.trim().toLowerCase();
    })
    .filter(Boolean)
    .concat([window.location.host.toLowerCase(), 'jwearstudio.com', 'www.jwearstudio.com']);

  var state = {
    open: false,
    messages: loadHistory(),
    products: {},
    streaming: false,
    controller: null,
    lastFocus: null
  };
  state.messages.forEach(function (m) {
    (m.products || []).forEach(function (card) {
      state.products[card.handle] = card;
    });
  });

  /* ------------------------------------------------------------------ */
  /* Storage                                                            */
  /* ------------------------------------------------------------------ */

  function loadHistory() {
    try {
      var parsed = JSON.parse(window.sessionStorage.getItem(HISTORY_KEY) || '[]');
      return Array.isArray(parsed)
        ? parsed.filter(function (m) {
            return m && (m.role === 'user' || m.role === 'assistant') && typeof m.content === 'string';
          })
        : [];
    } catch (e) {
      return [];
    }
  }

  function saveHistory() {
    try {
      window.sessionStorage.setItem(HISTORY_KEY, JSON.stringify(state.messages.slice(-MAX_STORED)));
    } catch (e) {}
  }

  function lead() {
    return window.JwLead || null;
  }

  function knownEmail() {
    return lead() ? lead().getEmail() : '';
  }

  /* ------------------------------------------------------------------ */
  /* Launcher placement via shared jw-fab-stack.js                      */
  /* ------------------------------------------------------------------ */

  function requestStack() {
    if (window.JwFabStack && typeof window.JwFabStack.request === 'function') {
      window.JwFabStack.request();
    } else if (window.JwFabStack && typeof window.JwFabStack.refresh === 'function') {
      window.JwFabStack.refresh();
    }
  }

  function syncViewport() {
    if (!window.visualViewport || !MOBILE_QUERY.matches) {
      root.style.removeProperty('--jw-chat-vh');
      root.style.removeProperty('--jw-chat-vtop');
      return;
    }
    root.style.setProperty('--jw-chat-vh', Math.round(window.visualViewport.height) + 'px');
    root.style.setProperty('--jw-chat-vtop', Math.round(window.visualViewport.offsetTop) + 'px');
  }

  /* ------------------------------------------------------------------ */
  /* Rendering                                                          */
  /* ------------------------------------------------------------------ */

  function escapeHtml(text) {
    return String(text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function unescapeHtml(text) {
    return String(text)
      .replace(/&#39;/g, "'")
      .replace(/&quot;/g, '"')
      .replace(/&gt;/g, '>')
      .replace(/&lt;/g, '<')
      .replace(/&amp;/g, '&');
  }

  /* Only same-store links (rewritten to the current host) and mailto are clickable. */
  function safeLink(rawUrl) {
    var url = unescapeHtml(rawUrl).replace(/[.,;:!?]+$/, '');
    if (/^mailto:[^\s@]+@[^\s@]+$/i.test(url)) return { href: url };
    var parsed;
    try {
      parsed = new URL(url, window.location.origin);
    } catch (e) {
      return null;
    }
    if (!/^https?:$/.test(parsed.protocol)) return null;
    if (storeHosts.indexOf(parsed.host.toLowerCase()) === -1) return null;
    var match = parsed.pathname.match(/\/products\/([a-z0-9-]+)/i);
    return {
      href: window.location.origin + parsed.pathname + parsed.search,
      handle: match ? match[1].toLowerCase() : ''
    };
  }

  function renderRich(text, handles) {
    var slots = [];
    var hold = function (html) {
      slots.push(html);
      return '\u0000' + (slots.length - 1) + '\u0000';
    };
    var anchor = function (link, label) {
      if (link.handle && handles.indexOf(link.handle) === -1) handles.push(link.handle);
      return hold('<a href="' + escapeHtml(link.href) + '">' + label + '</a>');
    };

    var html = escapeHtml(text);
    html = html.replace(/\[([^\]\n]{1,200})\]\(\s*([^)\s]+)\s*\)/g, function (m, label, url) {
      var link = safeLink(url);
      return link ? anchor(link, label) : label;
    });
    html = html.replace(/(^|[\s(])((?:https?:\/\/|mailto:)[^\s<)]+)/g, function (m, pre, url) {
      var link = safeLink(url);
      if (!link) return m;
      var label = link.handle ? 'View product' : escapeHtml(unescapeHtml(url).replace(/^mailto:/, ''));
      return pre + anchor(link, label);
    });
    html = html
      .replace(/\*\*([^*\n]+)\*\*/g, '<strong>$1</strong>')
      .replace(/(^|[^*])\*([^*\n]+)\*(?!\*)/g, '$1<em>$2</em>')
      .replace(/^#{1,6}\s+/gm, '');

    var out = [];
    var list = null;
    html.split(/\n/).forEach(function (line) {
      var item = line.match(/^\s*(?:[-*•]|\d+[.)])\s+(.*)$/);
      if (item) {
        if (!list) list = [];
        list.push('<li>' + item[1] + '</li>');
        return;
      }
      if (list) {
        out.push('<ul>' + list.join('') + '</ul>');
        list = null;
      }
      out.push(line.trim() ? '<p>' + line + '</p>' : '');
    });
    if (list) out.push('<ul>' + list.join('') + '</ul>');

    return out
      .join('')
      .replace(/\u0000(\d+)\u0000/g, function (m, i) {
        return slots[Number(i)];
      });
  }

  function nearBottom() {
    return body.scrollHeight - body.scrollTop - body.clientHeight < 96;
  }

  function scrollToEnd(force) {
    if (force || nearBottom()) body.scrollTop = body.scrollHeight;
  }

  function productChips(cards) {
    if (!cards || !cards.length) return null;
    var wrap = document.createElement('div');
    wrap.className = 'jw-chat__products';
    cards.slice(0, 3).forEach(function (card) {
      var link = safeLink(card.url);
      if (!link) return;
      var a = document.createElement('a');
      a.className = 'jw-chat__product';
      a.href = link.href;
      var img = card.image
        ? '<img src="' + escapeHtml(card.image) + '" alt="" width="44" height="55" loading="lazy" decoding="async">'
        : '<span class="jw-chat__product-ph" aria-hidden="true"></span>';
      a.innerHTML =
        img +
        '<span class="jw-chat__product-text"><span class="jw-chat__product-title">' +
        escapeHtml(card.title) +
        '</span><span class="jw-chat__product-price">' +
        escapeHtml(card.price || '') +
        (card.available === false ? ' · Sold out' : '') +
        '</span></span>';
      wrap.appendChild(a);
    });
    return wrap.children.length ? wrap : null;
  }

  function messageNode(message) {
    var row = document.createElement('div');
    row.className = 'jw-chat__msg jw-chat__msg--' + (message.role === 'user' ? 'user' : 'bot');
    var bubble = document.createElement('div');
    bubble.className = 'jw-chat__bubble';
    if (message.role === 'user') bubble.textContent = message.content;
    else bubble.innerHTML = renderRich(message.content, []);
    row.appendChild(bubble);
    var chips = productChips(message.products);
    if (chips) row.appendChild(chips);
    return row;
  }

  function renderLog() {
    log.innerHTML = '';
    if (welcomeText) log.appendChild(messageNode({ role: 'assistant', content: welcomeText }));
    state.messages.forEach(function (m) {
      log.appendChild(messageNode(m));
    });
    var hasUser = state.messages.some(function (m) {
      return m.role === 'user';
    });
    suggestions.hidden = hasUser || !suggestions.children.length;
  }

  function typingNode() {
    var row = document.createElement('div');
    row.className = 'jw-chat__msg jw-chat__msg--bot';
    row.innerHTML =
      '<div class="jw-chat__bubble jw-chat__typing"><span></span><span></span><span></span><span class="jw-chat__sr">Assistant is typing</span></div>';
    return row;
  }

  function errorNode(message, retry) {
    var row = document.createElement('div');
    row.className = 'jw-chat__msg jw-chat__msg--bot jw-chat__msg--error';
    var bubble = document.createElement('div');
    bubble.className = 'jw-chat__bubble';
    bubble.innerHTML = renderRich(message, []);
    row.appendChild(bubble);
    if (retry) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'jw-chat__retry';
      btn.textContent = 'Try again';
      btn.addEventListener('click', function () {
        row.remove();
        requestReply();
      });
      row.appendChild(btn);
    }
    return row;
  }

  function announce(text) {
    announcer.textContent = '';
    window.setTimeout(function () {
      announcer.textContent = text;
    }, 60);
  }

  function plain(text) {
    return String(text)
      .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
      .replace(/[*#_`]/g, '')
      .trim();
  }

  /* ------------------------------------------------------------------ */
  /* Views                                                              */
  /* ------------------------------------------------------------------ */

  function showView(view) {
    gate.hidden = view !== 'gate';
    offline.hidden = view !== 'offline';
    log.hidden = view !== 'chat';
    form.hidden = view !== 'chat';
    if (view !== 'chat') suggestions.hidden = true;
    panel.setAttribute('data-view', view);
  }

  function showChat(focus) {
    showView('chat');
    renderLog();
    scrollToEnd(true);
    if (focus) input.focus({ preventScroll: true });
    var email = knownEmail();
    if (email && lead() && listId) lead().subscribe({ email: email, siteId: siteId, listId: listId, source: 'Jwear AI chat' });
  }

  function chooseView(focus) {
    if (!endpoint) {
      showView('offline');
      if (focus) panel.focus({ preventScroll: true });
      return;
    }
    if (!knownEmail()) {
      showView('gate');
      if (focus) emailInput.focus({ preventScroll: true });
      return;
    }
    showChat(focus);
  }

  /* ------------------------------------------------------------------ */
  /* Open / close + focus trap                                          */
  /* ------------------------------------------------------------------ */

  function focusables() {
    return Array.prototype.filter.call(panel.querySelectorAll(FOCUSABLE), function (el) {
      return el.getClientRects().length > 0 && !el.closest('[hidden]');
    });
  }

  function onKeydown(event) {
    if (!state.open) return;
    if (event.key === 'Escape' || event.key === 'Esc') {
      event.preventDefault();
      close(true);
      return;
    }
    if (event.key !== 'Tab') return;
    var items = focusables();
    if (!items.length) {
      event.preventDefault();
      panel.focus();
      return;
    }
    var first = items[0];
    var last = items[items.length - 1];
    var active = document.activeElement;
    if (event.shiftKey && (active === first || active === panel || !panel.contains(active))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (active === last || !panel.contains(active))) {
      event.preventDefault();
      first.focus();
    }
  }

  function open() {
    if (state.open) return;
    state.open = true;
    state.lastFocus = document.activeElement;
    syncViewport();
    panel.hidden = false;
    panel.classList.remove('is-closing');
    void panel.offsetWidth;
    panel.classList.add('is-open');
    root.classList.add('is-open');
    launcher.setAttribute('aria-expanded', 'true');
    if (MOBILE_QUERY.matches) document.documentElement.classList.add('jw-chat-scroll-lock');
    document.addEventListener('keydown', onKeydown, true);
    chooseView(true);
    requestStack();
  }

  function close(restoreFocus) {
    if (!state.open) return;
    state.open = false;
    document.removeEventListener('keydown', onKeydown, true);
    panel.classList.remove('is-open');
    panel.classList.add('is-closing');
    root.classList.remove('is-open');
    launcher.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('jw-chat-scroll-lock');
    requestStack();
    var done = false;
    var finish = function () {
      if (done || state.open) return;
      done = true;
      panel.hidden = true;
      panel.classList.remove('is-closing');
      requestStack();
      if (restoreFocus && launcher && typeof launcher.focus === 'function') launcher.focus({ preventScroll: true });
    };
    panel.addEventListener('animationend', finish, { once: true });
    window.setTimeout(finish, reducedMotion.matches ? 0 : 260);
  }

  /* ------------------------------------------------------------------ */
  /* Email gate                                                         */
  /* ------------------------------------------------------------------ */

  gateForm.addEventListener('submit', function (event) {
    event.preventDefault();
    var api = lead();
    var email = api ? api.normalize(emailInput.value) : String(emailInput.value || '').trim().toLowerCase();
    emailInput.value = email;
    var valid = api ? api.isValid(email) : emailInput.checkValidity() && !!email;
    if (!valid) {
      emailInput.setAttribute('aria-invalid', 'true');
      gateStatus.textContent = 'Please enter a valid email address.';
      gateStatus.classList.add('is-error');
      emailInput.focus();
      return;
    }
    emailInput.removeAttribute('aria-invalid');
    gateStatus.textContent = '';
    gateStatus.classList.remove('is-error');
    if (api) api.remember(email);
    showChat(true);
  });

  emailInput.addEventListener('input', function () {
    if (emailInput.getAttribute('aria-invalid') === 'true') {
      emailInput.removeAttribute('aria-invalid');
      gateStatus.textContent = '';
      gateStatus.classList.remove('is-error');
    }
  });

  /* ------------------------------------------------------------------ */
  /* Messaging                                                          */
  /* ------------------------------------------------------------------ */

  function setStreaming(on) {
    state.streaming = on;
    sendBtn.disabled = on;
    sendBtn.setAttribute('aria-busy', on ? 'true' : 'false');
  }

  function autosize() {
    input.style.height = 'auto';
    input.style.height = Math.min(input.scrollHeight, 120) + 'px';
  }

  function sendMessage(text) {
    var value = String(text || '').trim().slice(0, MAX_CHARS);
    if (!value || state.streaming) return;
    state.messages.push({ role: 'user', content: value });
    saveHistory();
    log.appendChild(messageNode({ role: 'user', content: value }));
    suggestions.hidden = true;
    input.value = '';
    autosize();
    scrollToEnd(true);
    requestReply();
  }

  function friendlyError(code, message) {
    if (code === 'not_configured') {
      return 'Our assistant is not connected yet. Please email ' + supportEmail + ' and we’ll help you.';
    }
    if (code === 'network') return 'Connection problem — please check your internet and try again.';
    return (message || 'Sorry, something went wrong.') + (supportEmail ? ' You can also email ' + supportEmail + '.' : '');
  }

  function requestReply() {
    var typing = typingNode();
    log.appendChild(typing);
    scrollToEnd(true);
    announce('Assistant is typing');
    setStreaming(true);

    var controller = 'AbortController' in window ? new AbortController() : null;
    state.controller = controller;
    var reply = { role: 'assistant', content: '', products: [] };
    var cards = {};
    var row = null;
    var bubble = null;
    var frame = 0;
    var handles = [];
    var finished = false;

    function paint() {
      frame = 0;
      if (!bubble) return;
      var stick = nearBottom();
      handles = [];
      bubble.innerHTML = renderRich(reply.content, handles);
      if (stick) scrollToEnd(true);
    }

    function ensureBubble() {
      if (row) return;
      typing.remove();
      row = document.createElement('div');
      row.className = 'jw-chat__msg jw-chat__msg--bot';
      bubble = document.createElement('div');
      bubble.className = 'jw-chat__bubble is-streaming';
      row.appendChild(bubble);
      log.appendChild(row);
    }

    function finish(error) {
      if (finished) return;
      finished = true;
      if (frame) window.cancelAnimationFrame(frame);
      typing.remove();
      setStreaming(false);
      state.controller = null;
      if (reply.content.trim()) {
        ensureBubble();
        handles = [];
        bubble.innerHTML = renderRich(reply.content, handles);
        bubble.classList.remove('is-streaming');
        reply.products = handles
          .map(function (h) {
            return cards[h] || state.products[h];
          })
          .filter(Boolean)
          .slice(0, 3);
        var chips = productChips(reply.products);
        if (chips) row.appendChild(chips);
        state.messages.push(reply);
        saveHistory();
        announce('Assistant: ' + plain(reply.content));
        scrollToEnd(false);
      }
      if (error) {
        log.appendChild(errorNode(friendlyError(error.code, error.message), error.code !== 'not_configured'));
        announce(plain(friendlyError(error.code, error.message)));
        scrollToEnd(true);
      }
    }

    function handleEvent(name, data) {
      if (name === 'meta' && data && data.products) {
        data.products.forEach(function (card) {
          if (!card || !card.handle) return;
          cards[card.handle] = card;
          state.products[card.handle] = card;
        });
      } else if (name === 'delta' && data && typeof data.t === 'string') {
        ensureBubble();
        reply.content += data.t;
        if (!frame) frame = window.requestAnimationFrame(paint);
      } else if (name === 'error') {
        finish(reply.content ? null : { code: data && data.code, message: data && data.message });
      } else if (name === 'done') {
        finish(null);
      }
    }

    var history = state.messages.slice(-MAX_SENT).map(function (m) {
      return { role: m.role, content: m.content };
    });

    fetch(endpoint + '/chat', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'text/event-stream' },
      body: JSON.stringify({
        messages: history,
        email: knownEmail(),
        page_url: window.location.href,
        product_handle: productHandle || undefined
      }),
      signal: controller ? controller.signal : undefined
    })
      .then(function (response) {
        if (!response.ok || !response.body) {
          return response
            .json()
            .catch(function () {
              return {};
            })
            .then(function (data) {
              finish({ code: data.error || 'http_' + response.status, message: data.message });
            });
        }
        var reader = response.body.getReader();
        var decoder = new TextDecoder();
        var buffer = '';
        var pump = function () {
          return reader.read().then(function (result) {
            if (result.done) {
              finish(reply.content ? null : { code: 'unavailable' });
              return;
            }
            buffer += decoder.decode(result.value, { stream: true });
            var index;
            while ((index = buffer.indexOf('\n\n')) !== -1) {
              var frameText = buffer.slice(0, index);
              buffer = buffer.slice(index + 2);
              var name = 'message';
              var dataText = '';
              frameText.split('\n').forEach(function (line) {
                if (line.indexOf('event:') === 0) name = line.slice(6).trim();
                else if (line.indexOf('data:') === 0) dataText += line.slice(5).trim();
              });
              if (!dataText) continue;
              try {
                handleEvent(name, JSON.parse(dataText));
              } catch (e) {}
            }
            if (!finished) return pump();
            reader.cancel().catch(function () {});
          });
        };
        return pump();
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError' && !state.open) {
          finish(null);
          return;
        }
        finish(reply.content ? null : { code: 'network' });
      });
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    sendMessage(input.value);
  });

  input.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' && !event.shiftKey && !event.isComposing) {
      event.preventDefault();
      sendMessage(input.value);
    }
  });
  input.addEventListener('input', autosize);

  suggestions.addEventListener('click', function (event) {
    var chip = event.target.closest('[data-jw-chat-suggestion]');
    if (chip) sendMessage(chip.textContent);
  });

  /* ------------------------------------------------------------------ */
  /* Wire up                                                            */
  /* ------------------------------------------------------------------ */

  launcher.addEventListener('click', function () {
    if (state.open) close(true);
    else open();
  });
  closeBtn.addEventListener('click', function () {
    close(true);
  });

  /* Prestige adds html.lock for the cart drawer / menus: get out of the way. */
  if ('MutationObserver' in window) {
    new MutationObserver(function () {
      if (state.open && document.documentElement.classList.contains('lock')) close(false);
    }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  }

  window.addEventListener('resize', function () {
    requestStack();
    if (state.open) syncViewport();
  }, { passive: true });
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', function () {
      if (state.open) {
        syncViewport();
        scrollToEnd(false);
      }
    }, { passive: true });
  }

  window.JwChat = {
    open: open,
    close: function () {
      close(false);
    }
  };

  window.setTimeout(function () {
    launcher.hidden = false;
    if (!reducedMotion.matches) {
      launcher.classList.add('is-in');
      launcher.addEventListener('animationend', function () {
        launcher.classList.remove('is-in');
        requestStack();
      }, { once: true });
    }
    requestStack();
  }, 600);
})();
